import React, { useState } from 'react';

interface RepeatCustomerChipProps {
  prevDealValue?: number | null;
  prevDealClosedAt?: string | null;
}

function formatINRSimple(n: number): string {
  if (n >= 1_00_00_000) return `₹${(n / 1_00_00_000).toFixed(1)}Cr`;
  if (n >= 1_00_000) return `₹${(n / 1_00_000).toFixed(1)}L`;
  if (n >= 1_000) return `₹${(n / 1_000).toFixed(0)}K`;
  return `₹${n}`;
}

function formatDateSimple(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  } catch {
    return iso;
  }
}

export function RepeatCustomerChip({ prevDealValue, prevDealClosedAt }: RepeatCustomerChipProps) {
  const [hovered, setHovered] = useState(false);

  const hasTooltip = prevDealValue != null || prevDealClosedAt != null;

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          borderRadius: '9999px',
          padding: '2px 8px',
          fontSize: '10px',
          fontWeight: 600,
          lineHeight: 1.4,
          background: 'var(--saffron-50, #FBF3DF)',
          color: 'var(--saffron-600, #B87A2E)',
          border: '1px solid var(--saffron-100, #F5E7C9)',
          cursor: hasTooltip ? 'default' : 'default',
          whiteSpace: 'nowrap',
        }}
      >
        <span style={{ fontSize: '11px' }}>↻</span>
        Returning
      </span>

      {hovered && hasTooltip && (
        <span
          style={{
            position: 'absolute',
            bottom: 'calc(100% + 6px)',
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'var(--ink-0, #1B1713)',
            color: 'var(--ivory-1, #FAF7EF)',
            borderRadius: '6px',
            padding: '6px 10px',
            fontSize: '11px',
            lineHeight: 1.5,
            whiteSpace: 'nowrap',
            zIndex: 50,
            pointerEvents: 'none',
            boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
          }}
        >
          {prevDealValue != null && (
            <span style={{ display: 'block', fontWeight: 600 }}>
              Prev deal: {formatINRSimple(prevDealValue)}
            </span>
          )}
          {prevDealClosedAt && (
            <span style={{ display: 'block', opacity: 0.75 }}>
              Closed {formatDateSimple(prevDealClosedAt)}
            </span>
          )}
          {/* Caret */}
          <span
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderLeft: '5px solid transparent',
              borderRight: '5px solid transparent',
              borderTop: '5px solid var(--ink-0, #1B1713)',
            }}
          />
        </span>
      )}
    </span>
  );
}
